import axios from 'axios';

import { ResponseObj, VacinacoesFormData, VacinacaoSoftDeleteFormData } from '../../../back/src/types';
import { Vacinacao } from '../../../back/src/entity/Vacinacao';

const criaVacinacao = async (formData: VacinacoesFormData): Promise<ResponseObj<Vacinacao>> => {
  const res = await axios.post<ResponseObj<Vacinacao>>('vacinacoes', formData);
  return res.data;
};

const atualizaVacinacao = async (formData: VacinacoesFormData): Promise<ResponseObj<Vacinacao>> => {
  const res = await axios.put<ResponseObj<Vacinacao>>('vacinacoes', formData);
  return res.data;
};

const removeVacinacao = async (
  vacinacaoId: number,
  formData: VacinacaoSoftDeleteFormData,
): Promise<ResponseObj<Vacinacao>> => {
  const res = await axios.put<ResponseObj<Vacinacao>>(`vacinacoes/remover/${vacinacaoId}`, formData);
  return res.data;
};

const restauraVacinacao = async (
  vacinacaoId: number,
  formData: VacinacaoSoftDeleteFormData,
): Promise<ResponseObj<Vacinacao>> => {
  const res = await axios.put<ResponseObj<Vacinacao>>(`vacinacoes/restaurar/${vacinacaoId}`, formData);
  return res.data;
};

export default {
  criaVacinacao,
  atualizaVacinacao,
  removeVacinacao,
  restauraVacinacao,
};
